import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import PrintableLayout from './PrintableLayout.jsx';
import { SITE_URL } from '../../seo/siteConfig.js';
import heroDesktop from '../../assets/images/ehlyianha-faith-gil/ehlyianha-faith-gil-hero-portrait-desktop.webp';
import venueImg from '../../assets/images/ehlyianha-faith-gil/faith-venue-location.webp';
import dresscodeAttireGuide from '../../assets/images/ehlyianha-faith-gil/ehlyianha-dresscode-attire-guide.webp';
import gallery1 from '../../assets/images/ehlyianha-faith-gil/ehlyianha-gallery-1.webp';
import gallery2 from '../../assets/images/ehlyianha-faith-gil/ehlyianha-gallery-2.webp';
import gallery3 from '../../assets/images/ehlyianha-faith-gil/ehlyianha-gallery-3.webp';
import gallery4 from '../../assets/images/ehlyianha-faith-gil/ehlyianha-gallery-4.webp';
import stripPhoto1 from '../../assets/images/ehlyianha-faith-gil/ehlyianha-gallery-strip-1.webp';
import stripPhoto2 from '../../assets/images/ehlyianha-faith-gil/ehlyianha-gallery-strip-2.webp';
import stripPhoto3 from '../../assets/images/ehlyianha-faith-gil/ehlyianha-gallery-strip-3.webp';
import stripPhoto4 from '../../assets/images/ehlyianha-faith-gil/ehlyianha-gallery-strip-4.webp';
import logicaLogo from '../../assets/images/Logica (Black and White).webp';
import '../../styles/EhlyianhaFaithGilPrintable.css';
import '../../styles/EhlyianhaFaithGilPrintableResponsive.css';
import '../../styles/EhlyianhaFaithGilCutBoundaryFix.css';

const INVITATION_URL = `${SITE_URL}/invitations/custom/ehlyianha-faith-gil-debut`;
const MAP_URL = 'https://maps.google.com/?q=Sitio+Rosal+Pavilion+Patio+Robert';

const TRADITIONS = {
  spells: {
    label: '18 Sparkling Spells',
    icon: '🥂',
    description: 'Eighteen beloved souls raising their glasses in a jubilant toast for YHANA.',
    names: [
      'Shaira Saavedra', 'Azenyl Ricafrente', 'Mickey Magtaka', 'Hope Chu',
      'Mike Dela Cruz', 'Frence Lachica', 'Shane Valentino', 'Miggy Alcantara',
      'Andrei Balivia', 'Brydon Berango', 'Aeron Torres', 'Genre Bondoc',
      'Klyd Razon', 'Jhonmark Umangay', 'Jhonrey Cunanan', 'Esmerald Escoplo',
      'Rhenz Aranzanso', 'Yuan Daet',
    ],
  },
  treasures: {
    label: '18 Timeless Treasures',
    icon: '🎁',
    description: 'Eighteen cherished friends and family members bringing tokens of love and celebration.',
    names: [
      'Vina Almazan', 'Sheika Dorotheo', 'Thirdy Umangay', 'Aaron Gawat',
      'Aizze Luengas', 'Nikko Salvador', 'Max Cristobal', 'Shaira Saavedra',
      'Asher Canut', 'Anne Faye Cabel', 'Patricia Gonida', 'Pamela Gonida',
      'Pauleen Coronel', 'Annika Faustino', 'Kyle Fernandez', 'Nero Luengas',
      'Samantha Kris Tomarong', 'Rio Fernandez',
    ],
  },
  lights: {
    label: '18 Guiding Lights',
    icon: '🕯️',
    description: 'Eighteen voices of wisdom, warmth, and unwavering support lighting her path ahead.',
    names: [
      'Nimfa Albaño', 'Hilda Almazan', 'Lilia Jaramilla', 'Conchita Sumagaysay',
      'Miriam Ragasa', 'Wennie Dorotheo', 'Jhana Mae Umangay', 'Maricel Labaco',
      'Aezel Labaco', 'Vina Almazan', 'Jahnisse Sumagaysay', 'Julia Cruz',
      'Arly Luengas', 'Cheska Mariano', 'Augleen Luengas', 'Annika Faustino',
      'Rose Luengas', 'Rio Fernandez',
    ],
  },
  charms: {
    label: '18 Golden Charms',
    icon: '💛',
    description: 'Eighteen generous hearts recognized for their kindness, blessings, and support.',
    names: [
      'Nimfa Albaño', 'Lilia Jaramilla', 'Rod Fernandez', 'Johnsen Sumagaysay',
      'Joseph Sumagaysay', 'Joan Clemente', 'Daqui Canut', 'Sam Bacani',
      'Ruby Vergara', 'Kyle Fernandez', 'Felimon Sumagaysay', 'Aezel Labaco',
      'Mylene Sumagaysay', 'Arly Luengas', 'Bea Alo', 'Nerissa Luengas',
      'Cecile Cabael', 'Rose Luengas',
    ],
  },
  blooms: {
    label: '18 Enchanted Blooms',
    icon: '🌹',
    description: 'Eighteen remarkable souls presenting a rose and a heartfelt wish for YHANA.',
    names: [
      'Mharcuz Gil Almazan', 'Asher Canut', 'Yuri Canut', 'Jhonmark Umangay',
      'Rolando Umangay', 'Max Cristobal', 'Hans Dorothero', 'Tony Dorotheo',
      'Anton Gonida', 'Alex Labaco', 'Felimon Sumagaysay', 'Johnsen Sumagaysay',
      'Joseph Sumagaysay', 'Ariel Luengas', 'Kurt Fernandez', 'Kyle Fernandez',
      'Rodrigo Fernandez', 'Mark Gil Almazan',
    ],
  },
};

const REMINDERS = [
  ['Invited Guests Only', 'Only the guest or guests named on the invitation can be accommodated.'],
  ['Adults-Only Celebration', "Unless a child's name appears on the invitation, the celebration is adults only."],
  ['Arrival Time', 'Please arrive 30 minutes before the 4:00 PM program so you do not miss the grand entrance.'],
  ['Dress Code', 'Wear an elegant dress or polo longsleeve in the approved garden-inspired colors. No suits, please.'],
  ['Photos & Videos', 'You may take photos and videos, but please keep phones low during the formal program.'],
  ['Parking', 'Free parking is available at Sitio Rosal Pavilion and Patio Robert.'],
  ['RSVP Deadline', 'Please confirm attendance on or before July 15, 2026 through the digital invitation.'],
  ['Celebration End', 'The party is expected to end at around 10:00 PM.'],
];

const ALLOWED_COLORS = [
  ['Champagne', '#F7E7CE'],
  ['Dusty Rose', '#DCAE96'],
  ['Rose Gold', '#B76E79'],
  ['Beige / Tan', '#D2B48C'],
  ['Khaki', '#C3B091'],
  ['Light Gray', '#D3D3D3'],
  ['Charcoal', '#778899'],
  ['Black', '#1C1C1C'],
];

const AVOID_COLORS = [
  ['Maroon', '#800020'],
  ['Pink', '#FF91A4'],
  ['Dusty Blue', '#7FADC5'],
];

const GLIMPSE_PHOTOS = [gallery1, gallery2, gallery3, gallery4];
const GALLERY_PARTS = [
  [stripPhoto1, stripPhoto2],
  [stripPhoto3, stripPhoto4],
];

function BotanicalFrame({ dark = false }) {
  return (
    <div className={`yhp-frame${dark ? ' yhp-frame--dark' : ''}`} aria-hidden="true">
      <span className="yhp-corner yhp-corner--tl">❧</span>
      <span className="yhp-corner yhp-corner--tr">❧</span>
      <span className="yhp-corner yhp-corner--bl">❧</span>
      <span className="yhp-corner yhp-corner--br">❧</span>
    </div>
  );
}

function Divider({ light = false }) {
  return (
    <div className={`yhp-divider${light ? ' yhp-divider--light' : ''}`} aria-hidden="true">
      <span />
      <b>✦</b>
      <i>❀</i>
      <b>✦</b>
      <span />
    </div>
  );
}

function SectionHeading({ eyebrow, children, light = false }) {
  return (
    <header className={`yhp-heading${light ? ' yhp-heading--light' : ''}`}>
      {eyebrow && <p>{eyebrow}</p>}
      <h2>{children}</h2>
      <Divider light={light} />
    </header>
  );
}

function TraditionPanel({ tradition }) {
  return (
    <section className="yhp-tradition-panel">
      <div className="yhp-tradition-title-row">
        <span aria-hidden="true">{tradition.icon}</span>
        <div>
          <h3>{tradition.label}</h3>
          <p>{tradition.description}</p>
        </div>
      </div>
      <ol className="yhp-name-list">
        {tradition.names.map((name) => <li key={`${tradition.label}-${name}`}>{name}</li>)}
      </ol>
    </section>
  );
}

function QrCard({ value, title, helper, className = '' }) {
  return (
    <div className={`yhp-qr-card${className ? ` ${className}` : ''}`}>
      <QRCodeSVG value={value} size={160} bgColor="#fffaf2" fgColor="#6B1422" level="H" includeMargin />
      <div>
        <strong>{title}</strong>
        <span>{helper}</span>
      </div>
    </div>
  );
}

function PhotoFigure({ src, alt, className = '' }) {
  return (
    <figure className={`yhp-photo-cell${className ? ` ${className}` : ''}`}>
      <img src={src} alt={alt} />
    </figure>
  );
}

function GlimpsePage() {
  return (
    <article className="pl-page yhp-page yhp-paper yhp-page--glimpse" aria-label="A glimpse of the celebrant">
      <BotanicalFrame />
      <div className="pl-content yhp-content">
        <SectionHeading eyebrow="A glimpse of the celebrant">Ehlyianha Faith Gil</SectionHeading>
        <div className="yhp-glimpse-grid">
          {GLIMPSE_PHOTOS.map((src, index) => (
            <PhotoFigure
              key={src}
              src={src}
              alt={`Ehlyianha Faith Gil portrait ${index + 1}`}
              className={`yhp-glimpse-photo yhp-glimpse-photo--${index + 1}`}
            />
          ))}
        </div>
        <p className="yhp-photo-caption">Grace in every glance, with a beautiful new chapter beginning.</p>
      </div>
    </article>
  );
}

function GalleryPage({ photos, part }) {
  return (
    <article className="pl-page yhp-page yhp-paper yhp-page--gallery-two-up" aria-label={`Photo gallery part ${part}`}>
      <BotanicalFrame />
      <div className="pl-content yhp-content">
        <SectionHeading eyebrow="More moments to cherish">Photo Gallery</SectionHeading>
        <div className="yhp-gallery-two-up">
          {photos.map((src, index) => (
            <PhotoFigure
              key={src}
              src={src}
              alt={`Ehlyianha Faith Gil gallery portrait ${(part - 1) * 2 + index + 1}`}
              className={`yhp-gallery-two-up-photo yhp-gallery-two-up-photo--${index + 1}`}
            />
          ))}
        </div>
        <p className="yhp-photo-caption">Eighteen years of laughter, dreams, grace, and memories worth keeping forever.</p>
      </div>
    </article>
  );
}

export default function EhlyianhaFaithGilPrintable() {
  return (
    <PrintableLayout
      title="Ehlyianha Faith Gil — Printable Debut Invitation (12 pages)"
      filename="ehlyianha-faith-gil-debut-invitation"
      supportsBifold
    >
      {/* PAGE 1 — COVER */}
      <article
        className="pl-page yhp-page yhp-cover yhp-page--cover"
        aria-label="Cover page"
        style={{ backgroundImage: `url(${heroDesktop})` }}
      >
        <div className="yhp-cover-overlay" aria-hidden="true" />
        <BotanicalFrame dark />
        <div className="yhp-cover-copy">
          <p className="yhp-kicker yhp-kicker--light">You are warmly invited to celebrate</p>
          <h1>Ehlyianha <span>Faith Gil</span></h1>
          <p className="yhp-script">Turns Eighteen</p>
          <p className="yhp-theme">A Wild Flower Debut</p>
          <Divider light />
          <p className="yhp-cover-meta">Saturday · August 1, 2026 · 4:00 PM</p>
          <p className="yhp-cover-venue">Sitio Rosal Pavilion and Patio Robert</p>
          <p className="yhp-hashtag">#YHANAinHerEighteenEra</p>
        </div>
      </article>

      {/* PAGE 2 — GLIMPSE OF THE CELEBRANT */}
      <GlimpsePage />

      {/* PAGE 3 — MESSAGE & CELEBRATION DETAILS */}
      <article className="pl-page yhp-page yhp-paper yhp-page--welcome" aria-label="Invitation message and event details">
        <BotanicalFrame />
        <div className="pl-content yhp-content">
          <SectionHeading eyebrow="A message from the heart">Dearest Beloved Guests,</SectionHeading>
          <div className="yhp-janine-message">
            <p>
              With hearts overflowing with joy and gratitude, we invite you to witness a once-in-a-lifetime
              milestone — the beautiful blossoming of a young woman into all she is graciously destined to be.
            </p>
            <p>
              <strong>Ehlyianha Faith Gil</strong> is turning eighteen, and on this enchanting evening amidst
              wildflowers and golden light, we celebrate the beginning of a radiant new chapter woven in grace,
              love, and limitless possibility.
            </p>
            <blockquote>
              “Like a wildflower, she grew in places no one expected her to grow, and she bloomed beautifully.”
            </blockquote>
            <p className="yhp-signoff">With all our love,<span>The Almazan Family</span></p>
          </div>

          <section className="yhp-janine-details" aria-label="Celebration details">
            <h3>✦ &nbsp; Celebration Details &nbsp; ✦</h3>
            <div className="yhp-janine-details-grid">
              <div><span>Date</span><strong>Saturday, August 1, 2026</strong></div>
              <div><span>Time</span><strong>4:00 PM</strong></div>
              <div><span>Venue</span><strong>Sitio Rosal Pavilion and Patio Robert</strong></div>
              <div><span>Theme</span><strong>Wild Flower</strong></div>
              <div><span>Father</span><strong>Mark Gil Almazan</strong></div>
              <div><span>Mother</span><strong>Rachel Almazan</strong></div>
            </div>
          </section>
        </div>
      </article>

      {/* PAGE 4 — DRESS CODE & GUEST REMINDERS */}
      <article className="pl-page yhp-page yhp-paper yhp-page--dress-reminders" aria-label="Dress code and guest reminders">
        <BotanicalFrame />
        <div className="pl-content yhp-content">
          <SectionHeading eyebrow="Everything you need to know">Dress Code & Guest Reminders</SectionHeading>
          <div className="yhp-janine-two-panel">
            <section className="yhp-janine-panel yhp-dress-panel">
              <p className="yhp-panel-kicker">Dress for the wildflower garden</p>
              <h3>Elegant Garden Semi-Formal</h3>
              <img src={dresscodeAttireGuide} alt="Semi-formal wildflower debut attire guide" className="yhp-janine-dress-image" />
              <p className="yhp-panel-copy">
                Wear an elegant dress or polo longsleeve in soft garden-inspired colors. No suits, please.
              </p>
              <p className="yhp-small-heading">Allowed Colors</p>
              <div className="yhp-swatches yhp-swatches--janine">
                {ALLOWED_COLORS.map(([name, color]) => (
                  <span key={name}><i style={{ background: color }} />{name}</span>
                ))}
              </div>
              <div className="yhp-avoid yhp-avoid--janine">
                <strong>Please avoid</strong>
                {AVOID_COLORS.map(([name, color]) => (
                  <span key={name}><i style={{ background: color }} />{name}</span>
                ))}
              </div>
            </section>

            <section className="yhp-janine-panel yhp-reminders-panel">
              <p className="yhp-panel-kicker">A kind request from the family</p>
              <h3>Guest Reminders</h3>
              <div className="yhp-janine-reminder-grid">
                {REMINDERS.map(([title, text], index) => (
                  <div key={title} className="yhp-janine-reminder-item">
                    <span>{index + 1}</span>
                    <p><strong>{title}</strong>{text}</p>
                  </div>
                ))}
              </div>
            </section>
          </div>
        </div>
      </article>

      {/* PAGE 5 — TRADITIONS PART 1 */}
      <article className="pl-page yhp-page yhp-paper yhp-page--traditions" aria-label="Sparkling spells and timeless treasures">
        <BotanicalFrame />
        <div className="pl-content yhp-content">
          <SectionHeading eyebrow="An evening of grand tradition">Program Highlights — Part 1</SectionHeading>
          <div className="yhp-tradition-grid">
            <TraditionPanel tradition={TRADITIONS.spells} />
            <TraditionPanel tradition={TRADITIONS.treasures} />
          </div>
        </div>
      </article>

      {/* PAGE 6 — TRADITIONS PART 2 */}
      <article className="pl-page yhp-page yhp-paper yhp-page--traditions" aria-label="Guiding lights and golden charms">
        <BotanicalFrame />
        <div className="pl-content yhp-content">
          <SectionHeading eyebrow="With wisdom, warmth, and generous hearts">Program Highlights — Part 2</SectionHeading>
          <div className="yhp-tradition-grid">
            <TraditionPanel tradition={TRADITIONS.lights} />
            <TraditionPanel tradition={TRADITIONS.charms} />
          </div>
        </div>
      </article>

      {/* PAGE 7 — ENCHANTED BLOOMS */}
      <article className="pl-page yhp-page yhp-paper yhp-page--blooms" aria-label="Enchanted blooms">
        <BotanicalFrame />
        <div className="pl-content yhp-content">
          <SectionHeading eyebrow="Roses, wishes, and cherished bonds">18 Enchanted Blooms</SectionHeading>
          <div className="yhp-blooms-layout">
            <TraditionPanel tradition={TRADITIONS.blooms} />
            <aside className="yhp-program-note">
              <span aria-hidden="true">❀</span>
              <h3>A Night in Bloom</h3>
              <p>
                Every toast, candle, gift, charm, and rose fills the garden with memories YHANA will carry forever.
              </p>
              <p className="yhp-program-time">Program starts at 4:00 PM</p>
              <p>Please arrive by 3:30 PM.</p>
            </aside>
          </div>
        </div>
      </article>

      {/* PAGE 8 — VENUE & GIFT GUIDE */}
      <article className="pl-page yhp-page yhp-paper yhp-page--venue-janine" aria-label="Venue directions and gift guide">
        <BotanicalFrame />
        <div className="pl-content yhp-content">
          <SectionHeading eyebrow="Find your way to the celebration">The Venue</SectionHeading>
          <div className="yhp-venue-janine-grid">
            <div className="yhp-venue-janine-photo">
              <img src={venueImg} alt="Sitio Rosal Pavilion and Patio Robert" />
              <div>
                <strong>Sitio Rosal Pavilion and Patio Robert</strong>
                <span>Saturday · August 1, 2026 · 4:00 PM</span>
                <small>Free parking is available for all guests.</small>
              </div>
            </div>
            <div className="yhp-venue-janine-side">
              <QrCard value={MAP_URL} title="Venue Directions" helper="Scan to open Google Maps." className="yhp-map-qr-card" />
              <div className="yhp-gift-note">
                <p className="yhp-panel-kicker">A note from the celebrant</p>
                <h3>Gift Guide</h3>
                <p>
                  Your presence is already the most precious gift. If you wish to bring a token of love,
                  thoughtful suggestions include cash, essentials, or perfume.
                </p>
                <div><span>💵 Cash</span><span>✨ Essentials</span><span>🌸 Perfume</span></div>
              </div>
            </div>
          </div>
        </div>
      </article>

      {/* PAGES 9–10 — PHOTO GALLERY */}
      <GalleryPage photos={GALLERY_PARTS[0]} part={1} />
      <GalleryPage photos={GALLERY_PARTS[1]} part={2} />

      {/* PAGE 11 — DIGITAL INVITATION / RSVP */}
      <article className="pl-page yhp-page yhp-paper yhp-page--digital-qr" aria-label="Digital invitation and RSVP QR code">
        <BotanicalFrame />
        <div className="yhp-digital-qr-inner">
          <p className="yhp-panel-kicker">You’re invited</p>
          <h2>Scan to View the Digital Invitation</h2>
          <Divider />
          <div className="yhp-digital-qr-code">
            <QRCodeSVG value={INVITATION_URL} size={220} bgColor="#fffaf2" fgColor="#6B1422" level="H" includeMargin />
          </div>
          <p className="yhp-digital-qr-url">e-invitation.online/invitations/custom/ehlyianha-faith-gil-debut</p>
          <p className="yhp-digital-qr-copy">
            Scan the QR code to open the interactive invitation, submit your RSVP, review event details,
            and check important guest information directly from your phone.
          </p>
          <div className="yhp-rsvp-deadline">
            <strong>Kindly RSVP by July 15, 2026</strong>
            <span>We look forward to celebrating this beautiful milestone with you.</span>
          </div>
        </div>
      </article>

      {/* PAGE 12 — THANK YOU / CLOSING */}
      <article className="pl-page yhp-page yhp-closing yhp-page--closing" aria-label="Thank you and closing message">
        <BotanicalFrame dark />
        <div className="pl-content yhp-content yhp-closing-content">
          <p className="yhp-kicker yhp-kicker--light">With love and gratitude</p>
          <h2>Thank You for Being Part of Her Story</h2>
          <Divider light />
          <p>
            Your presence, warm wishes, and joyful laughter will make YHANA’s eighteenth birthday even more meaningful.
          </p>
          <blockquote>Bring your smiles, your dancing shoes, and your loudest cheers.</blockquote>
          <p>
            Let us celebrate, share happy tears, and create a night of beautiful memories we will always treasure.
          </p>
          <div className="yhp-closing-event">
            <strong>Ehlyianha Faith Gil · Turns Eighteen</strong>
            <span>Saturday · August 1, 2026 · 4:00 PM</span>
            <span>Sitio Rosal Pavilion and Patio Robert</span>
          </div>
          <p className="yhp-closing-hashtag">#YHANAinHerEighteenEra</p>
          <div className="yhp-brand">
            <img src={logicaLogo} alt="Logica Technology" />
            <span>Printable invitation by E-Invitation</span>
          </div>
        </div>
      </article>
    </PrintableLayout>
  );
}
